import { baseApi } from './baseApi';

export const TAG_HEALTH_RADAR = 'HealthRadar';

/**
 * GET /api/v1/medapp/health-radar/?language=pl|en
 * (jak prevention-shield: ten sam prefiks, Bearer, język jak w PreventionShieldService).
 */
const healthRadarApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchHealthRadar: builder.query({
      query: (language = 'pl') => {
        const params = new URLSearchParams({ language });
        return {
          url: `/medapp/health-radar/?${params.toString()}`,
          method: 'GET',
        };
      },
      transformResponse: (response) => response?.health_radar ?? null,
      providesTags: (result, error, language) => [{ type: TAG_HEALTH_RADAR, id: language ?? 'pl' }],
    }),
  }),
});

export const { useFetchHealthRadarQuery } = healthRadarApi;
